import { useParams } from "react-router-dom";
import { SupportPageContentContainer, SupportArticleContainer } from "@platform/features/support";

export function DashboardSupportArticlePage() {
  const { articleId } = useParams();

  return (
    <SupportPageContentContainer articleId={articleId} isArticlePage>
      <SupportArticleContainer
        articleId={articleId}
        className="px-4 pr-4 md:px-0 md:pr-8"
      />
    </SupportPageContentContainer>
  );
}

export default DashboardSupportArticlePage;


